import clevertap from "clevertap-web-sdk";
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

// components
import { CalendarPopup } from "components/Search/SearchPhone/CalendarPoup";
import { LocationPopup } from "components/Search/SearchPhone/LocationPopup";

// icons
// customHooks
import { useMediaQuery } from "customHooks/useMediaQuery";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// styles
import "./style.scss";
import capitalizeFirstLetter from "helpers/cap";

import { GuestPopup } from "components/Search/SearchPhone/GuestPoup";

import Footer from "components/Footer";
import { NewSeaerch } from "components/NewSearch";
import { NavbarAndSidebar } from "components/NavbarAndSidebar";
import Faq from "components/ListingNew/ListingNormal/Faqs/Faq";
import axios from "axios";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const PhoneLoginHandler = lazy(() =>
	import("components/LoginAndRegister/PhoneLoginHandler"),
);

const Modal = lazy(() => import("components/LoginAndRegister/Modal"));

const SortByPopup = lazy(() =>
	import("components/Search/SearchWeb/SortByPopup"),
);

const EmailLoginHandler = lazy(() =>
	import("components/LoginAndRegister/EmailLoginHandler"),
);

const SearchPage = ({ isVillas = "villas" }) => {
	const {
		setShowSortPopup,
		showSortPopup,
		setShowFilter,
		showFilter,
		query,
		allFillter,
		setShowLocationPopup,
		setShowCalendarPopup,
		setShowGuestPopup,
		showLocationPopup,
		showCalendarPopup,
		showGuestPopup,
		showLoginPopup,
		highlightData,
		setShowLoginPopup,
	} = useContext(SearchPageDataInterface);

	const [phone, setPhone] = useState(true);
	const width = useMediaQuery();
	const isMobile = width < 1070 ? true : false;

	useEffect(() => {
		window.history.scrollRestoration = "manual";
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (document) {
			const gScript = document.createElement("script");
			gScript.innerHTML = `gtag('event', 'search_page_view', {
						page_title: 'Search Page :: ${
							query?.get("location") ||
							window.location.pathname?.split("/")[2]?.split("-")[2]
						}',
						page_location: '${window.location.href}',
						send_to: 'G-YHNCEBVHD3'
						});`;
			gScript.defer = true;
			gScript.async = true;
			document.head.appendChild(gScript);

			clevertap.event.push("view_search_page", {
				page_url: `${window.location.href}`,
				location_name: `${
					query?.get("location") ||
					window.location.pathname?.split("/")[2]?.split("-")[2]
				}`,
				latitude: `${query?.get("lat")}`,
				longitude: `${query?.get("lon")}`,
				// amenities: `${query?.get("amenities")}`,
				occasion: `${query?.get("events")}`,
				rooms: `${query?.get("rooms")}`,
				guests: `${query?.get("guests")}`,
				// club: `${query?.get("club")}`,
				signature: `${query?.get("signature")}`,
				// checkin_date: new Date(query?.get("checkin")),
				// checkout_date: new Date(query?.get("checkout")),
				// sortby: `${query.get("sortby")}`.replace("%3A", ":").replace("+", " "),
				timestamp: new Date(),
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const [h1Tag, setH1Tag] = useState(false);
	useEffect(() => {
		if (document && document.querySelector(".not-visible-ssr")) {
			setH1Tag(true);
		}
	}, []);

	const [meta, setMeta] = useState({});
	const [loadMeta, setLoadMeta] = useState(false);
	const getMetaData = async () => {
		try {
			const data = document.getElementById("meta-schema");
			if (data) {
				setMeta(JSON.parse(data.innerText));
			}
		} catch (err) {
		} finally {
			setLoadMeta(true);
		}
	};

	const getMetaDynamic = async () => {
		const res = await axios(
			"https://go.saffronstays.com/api/seo-search/page?q=" +
				(query?.get("location") ||
					window.location.pathname?.split("/")[2]?.split("-")[2]),
		);

		if (res.data.success) {
			setMeta(res.data.data);
		}
	};

	useEffect(() => {
		if (
			query?.get("location") ||
			window.location.pathname?.split("/")[2]?.split("-")[2]
		)
			getMetaDynamic();
	}, [query?.get("location"), window.location.href]);

	useEffect(() => {
		getMetaData();
	}, []);

	return (
		<div className="search__page">
			{loadMeta && (
				<>
					<MetaTags>
						<title>
							{meta?.SEO_TITLE
								? meta?.SEO_TITLE
								: !window.location.pathname.includes("homestays")
								? `Best Luxury Villas in ${capitalizeFirstLetter(
										query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2],
								  )} with Pool | Bungalow In ${
										query?.get("location") ||
										window.location.pathname?.split("/")[2]?.split("-")[2]
								  } - SaffronStays`
								: `Best Homestays & Cottages in ${capitalizeFirstLetter(
										query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2],
								  )} | Bungalow In ${
										query?.get("location") ||
										window.location.pathname?.split("/")[2]?.split("-")[2]
								  } - SaffronStays`}
						</title>
						<meta
							name="description"
							content={
								meta?.SEO_DESCRIPTION
									? meta?.SEO_DESCRIPTION
									: `Book top rated luxury villas & bungalows in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )}. Explore best deals on villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with private pool, personal caretaker and sanitised homes on rent. Rent your villa in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} today at best price!`
							}
						/>
						<meta
							name="keywords"
							content={
								meta?.SEO_KEYWORDS
									? meta?.SEO_KEYWORDS
									: `luxury villas in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, villas in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, bungalows in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, homestays in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, book ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } villa on rent, resorts in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, hotel in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }, private pool villa in ${
											query.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  }`.toLowerCase()
							}
						/>
						{/* {searchResults?.data?.pages[0]?.data?.data[0]?.imagesList[0]?.ImgId ? (
					<meta
						property="og:image"
						content={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/f_auto,fl_force_strip.progressive:steep,q_60,w_1200,h_630,c_fill/${searchResults?.data?.pages[0]?.data?.data[0]?.imagesList[0]?.ImgId}.webp`}
					/>
				) : (
					""
				)} */}
						<link
							rel="canonical"
							href={`https://www.saffronstays.com/${isVillas}/${isVillas}-in-${
								query.get("location") ||
								window.location.pathname?.split("/")[2]?.split("-")[2]
							}`.toLowerCase()}
						/>

						<meta
							name="title"
							content={
								meta?.SEO_TITLE
									? meta?.SEO_TITLE
									: !window.location.pathname.includes("homestays")
									? `Best Luxury Villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with Pool | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
									: `Best Homestays & Cottages in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
							}
						/>

						<meta property="og:type" content="website" />
						<meta
							property="og:url"
							content={`https://www.saffronstays.com/${isVillas}/${isVillas}-in-${
								query.get("location") ||
								window.location.pathname?.split("/")[2]?.split("-")[2]
							}`.toLowerCase()}
						/>
						<meta
							property="og:title"
							content={
								meta?.SEO_TITLE
									? meta?.SEO_TITLE
									: !window.location.pathname.includes("homestays")
									? `Best Luxury Villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with Pool | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
									: `Best Homestays & Cottages in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
							}
						/>
						<meta
							property="og:description"
							content={
								meta?.SEO_DESCRIPTION
									? meta?.SEO_DESCRIPTION
									: `Book top rated luxury villas & bungalows in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )}. Explore best deals on villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with private pool, personal caretaker and sanitised homes on rent. Rent your villa in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} today at best price!`
							}
						/>

						<meta property="twitter:card" content="summary_large_image" />
						<meta
							property="twitter:url"
							content={`https://www.saffronstays.com/${isVillas}/${isVillas}-in-${
								query.get("location") ||
								window.location.pathname?.split("/")[2]?.split("-")[2]
							}`.toLowerCase()}
						/>
						<meta
							property="twitter:title"
							content={
								meta?.SEO_TITLE
									? meta?.SEO_TITLE
									: !window.location.pathname.includes("homestays")
									? `Best Luxury Villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with Pool | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
									: `Best Homestays & Cottages in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} | Bungalow In ${
											query?.get("location") ||
											window.location.pathname?.split("/")[2]?.split("-")[2]
									  } - SaffronStays`
							}
						/>
						<meta
							property="twitter:description"
							content={
								meta?.SEO_DESCRIPTION
									? meta?.SEO_DESCRIPTION
									: `Book top rated luxury villas & bungalows in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )}. Explore best deals on villas in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} with private pool, personal caretaker and sanitised homes on rent. Rent your villa in ${capitalizeFirstLetter(
											query?.get("location") ||
												window.location.pathname?.split("/")[2]?.split("-")[2],
									  )} today at best price!`
							}
						/>
					</MetaTags>
					{!h1Tag && (
						<h1 class="not-visible">
							{meta?.SEO_DESCRIPTION
								? meta?.SEO_DESCRIPTION
								: `Best luxury villas in
							${capitalizeFirstLetter(
								query?.get("location") ||
									window.location.pathname?.split("/")[2]?.split("-")[2],
							)} with private pool and amenities. Our popular villas in & around{" "}
							${capitalizeFirstLetter(
								query?.get("location") ||
									window.location.pathname?.split("/")[2]?.split("-")[2],
							)} are perfect to host memorable getaway experiences.`}
						</h1>
					)}
				</>
			)}

			<NavbarAndSidebar />
			<NewSeaerch />

			<SearchFaq
				location={capitalizeFirstLetter(
					query?.get("location") ||
						window.location.pathname?.split("/")[2]?.split("-")[2],
				)}
			/>
			<SEOBanner
				data={meta}
				location={capitalizeFirstLetter(
					query?.get("location") ||
						window.location.pathname?.split("/")[2]?.split("-")[2],
				)}
			/>
			<PopularLocations
				location={capitalizeFirstLetter(
					query?.get("location") ||
						window.location.pathname?.split("/")[2]?.split("-")[2],
				)}
			/>
			<HomeStays
				location={capitalizeFirstLetter(
					query?.get("location") ||
						window.location.pathname?.split("/")[2]?.split("-")[2],
				)}
			/>

			{/* <p className="seo-description">{meta?.DESCRIPTION}</p> */}
			<Footer />

			{showGuestPopup && (
				<Modal
					shouldShow={showGuestPopup}
					onRequestClose={() => setShowGuestPopup(false)}
				>
					<GuestPopup />
				</Modal>
			)}
			{showLoginPopup && (
				<Modal
					shouldShow={showLoginPopup}
					onRequestClose={() => setShowLoginPopup(false)}
				>
					{phone ? (
						<PhoneLoginHandler
							onRequestClose={() => setShowLoginPopup(false)}
							setPhone={setPhone}
							phone={phone}
						/>
					) : (
						<EmailLoginHandler
							onRequestClose={() => setShowLoginPopup(false)}
							setPhone={setPhone}
							phone={phone}
						/>
					)}
				</Modal>
			)}
			{showSortPopup && (
				<Modal
					shouldShow={showSortPopup}
					onRequestClose={() => setShowSortPopup(false)}
				>
					<SortByPopup />
				</Modal>
			)}
			{showLocationPopup && (
				<Modal
					shouldShow={showLocationPopup}
					onRequestClose={() => setShowLocationPopup(false)}
				>
					<LocationPopup />
				</Modal>
			)}
			{showCalendarPopup && (
				<Modal
					shouldShow={showCalendarPopup}
					onRequestClose={() => setShowCalendarPopup(false)}
				>
					<CalendarPopup />
				</Modal>
			)}
		</div>
	);
};

export default SearchPage;

const PopularLocations = ({ location }) => {
	const [data, setData] = useState([]);

	const getInit = async () => {
		try {
			const res = await axios(
				"https://go.saffronstays.com/api/search-popular?q=" + location,
			);
			if (res.data.success) {
				setData(res.data.data);
			}
		} catch (err) {
			setData([]);
		}
	};

	useEffect(() => {
		getInit();
	}, []);

	if (data.length)
		return (
			<div className="location-wrapper">
				<h2>Popular attraction near {location}</h2>
				<div className="location-container">
					{data.map((ele) => {
						return (
							<a href={ele.url + "&nearby=true"}>Villas Near {ele.text}</a>
						);
					})}
				</div>
			</div>
		);
	return null;
};

const HomeStays = ({ location }) => {
	const [data, setData] = useState({});
	const getInit = async () => {
		const res = await axios(
			"https://go.saffronstays.com/api/search-seo?place=" + location,
		);
		if (res.data.success) {
			setData(res.data.data);
		}
	};
	useEffect(() => {
		getInit();
	}, []);

	const genLink = (amen, loc) => {
		switch (amen) {
			case "breakfast":
				return `/villas/villas-in-${loc}?breakfast=true`;
			case "wifi":
				return `/villas/villas-in-${loc}?more=68`;
			case "pool":
				return `/villas/villas-in-${loc}?amenities=28`;
			case "homestays":
				return `/homestays/homestays-in-${loc}`;
			default:
				return "/#";
		}
	};

	return (
		<div className="homestays-warapper">
			{Object.keys(data)?.length !== 0 &&
				Object.keys(data).map((ele) => {
					if (data[ele])
						return (
							<div className="homestays-container">
								<a
									style={{
										textDecoration: "none",
									}}
									href={genLink(ele, location)}
								>
									<h2>
										{ele === "homestays"
											? `Homestays near ${location}`
											: `${
													window.location.pathname.includes("homestays")
														? "Homes"
														: "Villas"
											  } Near ${location} with ${capitalizeFirstLetter(ele)}`}
									</h2>
								</a>
								<div className="homestays-card-wrapper">
									{data[ele] &&
										data[ele].map((e) => {
											return <HomeStayCard location={location} {...e} />;
										})}
								</div>
							</div>
						);
					return null;
				})}
		</div>
	);
};

const HomeStayCard = ({
	TITLE,
	ID,
	DESCRIPTION,
	RATING,
	IMAGE,
	PER_NIGHT_CHARGE,
	AMENITY_CATEGORY,
	SEO_URL,
	FILE_REFERENCE,
	location,
}) => {
	const thumbnail = IMAGE?.split("/").reverse()[0].split("_")[1];
	return (
		<a
			href={"/view/" + SEO_URL + "-" + ID}
			className="homestays-card"
			itemscope="true"
			itemtype="https://schema.org/Hotel"
		>
			<div className="top-detail">
				<LazyLoadImage
					itemprop="photo"
					effect={"blur"}
					src={
						"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/w_100,h_100,c_scale/" +
						thumbnail +
						".webp"
					}
					alt={TITLE}
					className="homestays-image"
				/>
				<div className="homestays-detail">
					<div aria-label="villa title" itemprop="name" className="villa-title">
						{FILE_REFERENCE.split("-")[0]}
					</div>
					<div
						aria-label="villa price"
						itemprop="priceRange"
						className="villa-price"
					>
						<b>₹ {PER_NIGHT_CHARGE}</b> /night
					</div>
				</div>
			</div>
			<div itemprop="description" className="villa-description">
				{DESCRIPTION}
			</div>
		</a>
	);
};

const SearchFaq = ({ location }) => {
	const [data, setData] = useState([]);
	const getInit = async () => {
		const res = await axios(
			"https://go.saffronstays.com/api/hightlight?location=" + location,
		);
		if (res.data.success && res.data.data?.length !== 0) {
			setData(res.data.data);
		}
	};
	useEffect(() => {
		getInit();
	}, []);
	return (
		<div className="search-faqs">
			<div className="search-faq-header">
				<center>FAQs</center>
			</div>
			<Faq
				question_text={`What is the price range for villas in ${location}?`}
				question_answer={`Make your fondest memories at our villas, homestays and estates in ${location}. We have villas ranging from Rs. 5000 to Rs. 60000+ per night.`}
			/>
			<Faq
				question_text={`How many villas in ${location} are available?`}
				question_answer={`We have over 30+ villas available for the ${location}. Book Now!`}
			/>

			<Faq
				question_text={`What are the amenities SaffronStays offers in their villas in ${location}?`}
				question_answer={`SaffronStays offers a variety of amenities including private pool, outdoor bar, sauna/spa, anniversary celebrations, wifi, barbeque and bonfire`}
			/>

			{data.length ? (
				<Faq
					question_text={`What are the top villas in ${location}?`}
					question_answer={`We have a variety of pool villas with luxurious amenities. Our top villas include ${data
						.map((ele) => ele.name.split(" - ")[0])
						.join(
							", ",
						)} and others. Please check our page for great discounts and more details.`}
				/>
			) : null}
		</div>
	);
};

const SEOBanner = ({ data, location }) => {
	const nearby = JSON.parse(data?.POPULAR_PLACES_AROUND || "{}");
	const [view, setView] = useState(true);
	return (
		<div className={`seo-city-wrapper ${view ? "seo-city-view" : ""}`}>
			{view && (
				<button
					className="seo-view-btn"
					onClick={() => {
						setView(!view);
					}}
				>
					See More
				</button>
			)}
			<section>
				{data.SEO_CONTENT && <h2>Stay in {location}</h2>}
				{/* {data.SEO_DESCRIPTION && (
					<>
						<h3>Complete Guide About location</h3>
						<p>{data.DESCRIPTION}</p>
					</>
				)} */}
				{data.SEO_CONTENT ? (
					<section
						dangerouslySetInnerHTML={{ __html: data.SEO_CONTENT }}
					></section>
				) : (
					data.DESCRIPTION && (
						<>
							<h3>Complete Guide About location</h3>
							<p>{data.DESCRIPTION}</p>
						</>
					)
				)}
			</section>
			{data.villas && (
				<section>
					<h2>Villas in {location} Price</h2>
					<div>
						<div className="seo-list-title">
							<div>Villas in {location}</div>
							<div>Price per night stay</div>
						</div>
						<ol>
							{data.villas?.map((ele) => {
								return (
									<li>
										<a href={"/view/" + ele.ID}>
											{ele?.FILE_REFERENCE?.split("-")[0]}
										</a>
										<div>
											{new Intl.NumberFormat("en-IN", {
												style: "currency",
												currency: "INR",
											}).format(ele.PER_NIGHT_CHARGE)}
										</div>
									</li>
								);
							})}
						</ol>
					</div>
				</section>
			)}
			{nearby && Object.keys(nearby).length > 0 && (
				<section>
					<h2>Book Villas near {data.TITLE}</h2>
					<table>
						<tbody>
							{Object.keys(nearby)
								.reduce((rows, key, i) => {
									const rowIndex = Math.floor(i / 3);
									if (!rows[rowIndex]) rows[rowIndex] = [];
									rows[rowIndex].push(key);
									return rows;
								}, [])
								.map((row, i) => (
									<tr key={i}>
										{row.map((e) => (
											<td key={e}>
												<a href={`/villas/villas-in-${e}` + "?nearby=true"}>
													Villas in {e}
												</a>
											</td>
										))}
									</tr>
								))}
						</tbody>
					</table>
				</section>
			)}
		</div>
	);
};
